/* tslint:disable:react-a11y-anchors */
import * as React from 'react'

import { IMatch } from '../../../../../../typings/searchResults'
import ImagePreview from '../../../../../shared/components/imagePreview'
import ImagePreviewWithCarousel from '../../../../../shared/components/imagePreviewWithCarousel'
import FeatureContainer from '../../../../../shared/containers/feature/featureContainer'
import ImagePlaceholder from '../../../imagePlaceholder'

interface IProps {
  item: IMatch
  rank: number
  onItemLinkClick: React.EventHandler<any>
}

const Preview = ({ item, rank, onItemLinkClick }: IProps) => {
  return (
    <React.Fragment>
      <FeatureContainer name="item-preview-with-carousel">
        <ImagePreviewWithCarousel
          item={item}
          rank={rank}
          onItemLinkClick={onItemLinkClick}
        />
      </FeatureContainer>
      <FeatureContainer name="!item-preview-with-carousel">
        <a href={`${item.url}?s_rank=${rank}`} onClick={onItemLinkClick}>
          <ImagePlaceholder ratio={0.5}>
            <ImagePreview item={item} />
          </ImagePlaceholder>
        </a>
      </FeatureContainer>
    </React.Fragment>
  )
}

export default Preview
